import React, { useState } from "react";
import { motion } from "framer-motion";
import Header from "../components/Header";
import { useLocation } from "react-router-dom";
import UnifiedVehicleForm from "./unifiedVehicleForm";

const Quotation = () => {
  const location = useLocation();
  const data = location.state;
  const [formData, setFormData] = useState({
    ncbOfPreviousPolicy: data?.ncbOfPreviousPolicy || "",
    ODInsurer: data?.ODInsurer || "",
    userId: data?.userId || "",
    vehicleType: data?.vehicleType || "",
    userType: data?.userType || "",
    policyType: data?.policyType || "",
    previousPolicytype: data?.previousPolicytype || "",
    previousYearclame: data?.previousYearclame || "",
    policyExpirydate: data?.policyExpirydate || "",
    vehicleChassis: data?.vehicleChassis || "",
    policyMorethan90: data?.policyMorethan90 || false,
    registerNumber: data?.registerNumber || "",
    registrationDate: data?.registrationDate || "",
    make: data?.make || "",
    vehicleModel: data?.vehicleModel || "",
    GVC: data?.GVC || "",
    manufactureDate: data?.manufactureDate || "",
    fuelType: data?.fuelType || "",
    vehicleEngineNumber: data?.vehicleEngineNumber || "",
    attachPreviouspolicy: data?.attachPreviouspolicy || "",
    previousPolicyURL: data?.previousPolicyURL || "",
    vehicleDetailURL: data?.vehicleDetailURL || "",
    ownerDetail: {
      ownerName: data?.ownerDetail?.ownerName || "",
      ownerPhone: data?.ownerDetail?.ownerPhone || "",
      ownerAddress: data?.ownerDetail?.ownerAddress || "",
      ownerEmail: data?.ownerDetail?.ownerEmail || "",
    },
    requestSent: true,
    quotationMade: false,
    paymentDone: false,
    policyUpdated: false,
  });

  const [visible, setVisible] = useState(true);
  const [comments, setComments] = useState(data?.comments || []);

  const handleFinalSubmit = (submittedData) => {
    // Transform the data to match the schema
    const finalData = {
      ...formData,
      vehicleType: submittedData.vehicleType,
      policyType: submittedData.policyType,
      previousPolicytype: submittedData.previousPolicytype,
      previousYearclame: submittedData.previousYearclame,
      policyExpirydate: submittedData.policyExpirydate,
      policyMorethan90: submittedData.policyMorethan90,
      ncbOfPreviousPolicy: submittedData.ncbOfPreviousPolicy,
      ODInsurer: submittedData.ODInsurer,
      registerNumber: submittedData.registerNumber,
      make: submittedData.make,
      vehicleModel: submittedData.model,
      GVC: submittedData.ccGvc,
      registrationDate: submittedData.registrationDate,
      manufactureDate: submittedData.manufactureYear,
      fuelType: submittedData.fuelType,
      vehicleChassis: submittedData.chassisNumber,
      vehicleEngineNumber: submittedData.engineNumber,
      previousPolicyURL: submittedData.previousPolicyURL,
      vehicleDetailURL: submittedData.vehicleDetailURL,
      ownerDetail: {
        ownerName: submittedData.ownerDetail.ownerName,
        ownerPhone: submittedData.ownerDetail.ownerPhone,
        ownerAddress: submittedData.ownerDetail.ownerAddress,
        ownerEmail: submittedData.ownerDetail.ownerEmail,
      },
    };

    console.log("Final submitted form data:", finalData);
    // TODO: Add backend submission logic
  };

  return (
    <div className="relative">
      <Header />

      {/* Comments Section */}
      {comments.length > 0 && visible && (
        <div className="flex justify-center items-center">
          <div className="border mt-3 p-4 rounded-md relative max-w-2xl w-full">
            <button
              className="absolute top-2 right-2 text-red-700 font-bold hover:text-red-900"
              onClick={() => setVisible(false)}
            >
              &times;
            </button>
            {comments.map((obj, index) => (
              <div
                key={index}
                className="mb-2 border border-red-400 bg-red-200 text-red-700 rounded p-2"
              >
                <h2 className="font-semibold">{obj?.discription}</h2>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="bg-white flex flex-col justify-center items-center">
        <div className="w-full max-w-4xl">
          <motion.div
            key="merged-form"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="w-full"
          >
            <UnifiedVehicleForm
              data={{ ...formData, _id: data?._id }}
              onSubmit={handleFinalSubmit}
            />
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Quotation;
